import styled, { type DefaultTheme, type StyledComponent } from 'styled-components';

import { COLOR } from '#@/shared/utils/styles';

import { Body } from '../Text';

const AdjacentLabel = styled(Body).attrs({ variant: 'small', color: COLOR.textTertiary })`
  line-height: 1; /* to prevent label going off to the top */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
`;

export const PrefixLabel: StyledComponent<'div', DefaultTheme> = styled(AdjacentLabel)`
  left: 12px;
`;

export const SuffixLabel: StyledComponent<'div', DefaultTheme> = styled(AdjacentLabel)`
  right: 12px;
`;
